export default () => ({
  dialog: {
    minWidth: '418px',
  },
  formGroupSelect: {
    marginBottom: '20px',
  },
});
